import { render } from "./tool.vue?vue&type=template&id=0fd14b2c&scoped=true"
const script = {}

import "./tool.vue?vue&type=style&index=0&id=0fd14b2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd14b2c"]])

export default __exports__